/**
 * Проверяет, что карточка сейчас находится в указанном активном списке (не архивная).
 */
export default (cardIdsInList, cardId) => {
  if (!cardId || !cardIdsInList) {
    return false;
  }

  if (cardIdsInList instanceof Set) {
    return cardIdsInList.has(String(cardId));
  }

  if (Array.isArray(cardIdsInList)) {
    return cardIdsInList.includes(String(cardId)) || cardIdsInList.includes(Number(cardId));
  }

  return false;
};
